module.exports = __webpack_public_path__ + "media/images/ir/management/governance/img_governance-da17de78c405ec75aecdd844b5af66e8.svg";